import React from 'react'

const ExamInstruction = () => {
    return (
        <div>
            1. The Answer Sheet is inside this Test Booklet. When
            you are directed to open the Test Booklet, take out the
            Answer Sheet and fill in the particulars on ORIGINAL
            Copy carefully with blue/black ball point pen only.<br></br>
            2. The test is of 3 hours and this Test Booklet
            contains 180 questions. Each question carries 4 marks.
            For each correct response, the candidate will get 4 marks.
            For each incorrect response, one mark will be deducted
            from the total scores. The maximum marks are 720.<br></br>
            3. Use Blue/Black Ball Point Pen only for writing
            particulars on this page/marking responses on Answer
            Sheet.<br></br>
            4. Rough work is to be done in the space provided for this
            purpose in the Test Booklet only.<br></br>
            5. On completion of the test, the candidate must hand
            over the Answer Sheet (ORIGINAL and OFFICE
            Copy) to the Invigilator before leaving the Room/
            Hall. The candidates are allowed to take away this Test
            Booklet with them.
        </div>
    )
}

export default ExamInstruction
